import { render, staticRenderFns } from "./doctorday.vue?vue&type=template&id=735681a8&scoped=true&"
import script from "./doctorday.vue?vue&type=script&lang=js&"
export * from "./doctorday.vue?vue&type=script&lang=js&"
import style0 from "./doctorday.vue?vue&type=style&index=0&id=735681a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735681a8",
  null
  
)

export default component.exports